module.exports = __webpack_public_path__ + "img/relationships_2.96a3594b.png";